var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpfaith(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.5C4.14844 8.5 4.5 8.85156 4.5 9.25V10.375L6.79688 8.66406C6.91406 8.57031 7.07812 8.5 7.24219 8.5H10.5C10.8984 8.5 11.25 8.17188 11.25 7.75V1C11.25 0.601562 10.8984 0.25 10.5 0.25H1.5C1.07812 0.25 0.75 0.601562 0.75 1V7.75C0.75 8.17188 1.07812 8.5 1.5 8.5H3.75ZM0 1C0 0.179688 0.65625 -0.5 1.5 -0.5H10.5C11.3203 -0.5 12 0.179688 12 1V7.75C12 8.59375 11.3203 9.25 10.5 9.25H7.24219L4.33594 11.4297C4.21875 11.5234 4.07812 11.5234 3.9375 11.4766C3.82031 11.4062 3.75 11.2891 3.75 11.125V10V9.25H3H1.5C0.65625 9.25 0 8.59375 0 7.75V1Z",
    fill: "#2AAD8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 826,
    height: 634,
    fill: "white",
    transform: "translate(-34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpfaith);
export default __webpack_public_path__ + "static/media/cpfaith.7c79b18a6676918bad49a38b8df49263.svg";
export { ForwardRef as ReactComponent };